import { useEffect, useState, useRef } from "react";

export const useScrollToHash = (items, componentName) => {
  const [index, setIndex] = useState(null);
  const previousAnchorRef = useRef(null);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = decodeURIComponent(window.location.hash.slice(1));
      if (!hash || !items || !items.length) return;

      const currentAnchor = document.querySelector(`a[name="${hash}"]`);

      if (currentAnchor) {
        // Scroll into view
        currentAnchor.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest",
        });

        // Clear previous outline
        if (
          previousAnchorRef.current &&
          previousAnchorRef.current !== currentAnchor
        ) {
          clearOutline(previousAnchorRef.current);
        }

        // Apply outline
        currentAnchor.style.outline = "2px solid #000";
        currentAnchor.style.borderRadius = "2px";
        currentAnchor.style.marginRight = "2px";
        currentAnchor.style.marginLeft = "2px";

        previousAnchorRef.current = currentAnchor;

        // Listen once for user click to remove outline
        const handleClick = () => {
          if (previousAnchorRef.current) {
            clearOutline(previousAnchorRef.current);
            previousAnchorRef.current = null;
          }
          document.removeEventListener("click", handleClick);
        };

        document.addEventListener("click", handleClick, { once: true });

        // Match index
        const matchedIndex = items.findIndex((item, index) => {
          let expectedName;
          switch (componentName) {
            case "accordion":
              expectedName =
                item?.title &&
                `${item.title.replace("?", "").split(" ").join("")}-${index}`;
              break;
            case "tabs":
              expectedName = `panel-${index}`;
              break;
            default:
              return false;
          }
          return expectedName === hash;
        });

        if (matchedIndex !== -1) {
          setIndex(matchedIndex);
        }
      }
    };

    const clearOutline = (element) => {
      element.style.outline = "inherit";
      element.style.borderRadius = "0";
      element.style.marginRight = "0";
      element.style.marginLeft = "0";
    };

    // Initial trigger and listener
    handleHashChange();
    window.addEventListener("hashchange", handleHashChange);

    return () => {
      window.removeEventListener("hashchange", handleHashChange);
    };
  }, [items, componentName]);

  return index;
};
